export const blind75 = {
  Arrays: [
    {
      id: 'arr_1',
      qs: 'Two Sum',
      yt: 'https://youtu.be/TCaBnVIllrQ?si=kSBXls68X70QCn4B',
      qs_link: 'https://leetcode.com/problems/two-sum/',
      level: 'easy',
    },
    {
      id: 'arr_2',
      qs: 'Best Time to Buy and Sell Stock',
      yt: 'https://www.youtube.com/watch?v=iTvEXpOAyHY',
      qs_link: 'https://leetcode.com/problems/best-time-to-buy-and-sell-stock/',
      level: 'easy',
    },
    {
      id: 'arr_3',
      qs: 'Contains Duplicate',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/contains-duplicate/',
      level: 'easy',
    },
    {
      id: 'arr_4',
      qs: 'Product of Array Except Self',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/product-of-array-except-self/',
      level: 'medium',
    },
    {
      id: 'arr_5',
      qs: 'Maximum Subarray',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/maximum-subarray/',
      level: 'medium',
    },
    {
      id: 'arr_6',
      qs: 'Maximum Product Subarray',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/maximum-product-subarray/',
      level: 'medium',
    },
    {
      id: 'arr_7',
      qs: 'Find Minimum in Rotated Sorted Array',
      yt: 'https://youtu.be/Jin6vO0MdzY?si=LFJy8D86a9ZMVaXI',
      qs_link: 'https://leetcode.com/problems/find-minimum-in-rotated-sorted-array/',
      level: 'medium',
    },
    {
      id: 'arr_8',
      qs: 'Search in Rotated Sorted Array',
      yt: 'https://youtu.be/U1VsdRgVevY?si=vp2o5yj5_0kKCq9a',
      qs_link: 'https://leetcode.com/problems/search-in-rotated-sorted-array/',
      level: 'medium',
    },
    {
      id: 'arr_9',
      qs: '3 Sum',
      yt: 'https://youtu.be/_cBWWebTVpI?si=XzauYdL0Q69_7R2d',
      qs_link: 'https://leetcode.com/problems/3sum/',
      level: 'medium',
    },
    {
      id: 'arr_10',
      qs: 'Container With Most Water',
      yt: 'https://youtu.be/KVU4JNNJkVg?si=1QHQn6EzDcpkqn7E',
      qs_link: 'https://leetcode.com/problems/container-with-most-water/',
      level: 'medium',
    },
  ],
  Bitmanipulation: [
    {
      id: 'bit_1',
      qs: 'Number of 1 Bits',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/number-of-1-bits/',
      level: 'easy',
    },
    {
      id: 'bit_2',
      qs: 'Counting Bits',
      yt: 'https://youtu.be/uwOz378g3ew?si=m37tlkg7OoPoxP_9',
      qs_link: 'https://leetcode.com/problems/counting-bits/',
      level: 'easy',
    },
    {
      id: 'bit_3',
      qs: 'Missing Number',
      yt: 'https://www.youtube.com/watch?v=lpyQGkbDvqI',
      qs_link: 'https://leetcode.com/problems/missing-number',
      level: 'easy',
    },
    {
      id: 'bit_4',
      qs: 'Reverse Bits',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/reverse-bits/',
      level: 'easy',
    },
    {
      id: 'bit_5',
      qs: 'Sum of Two Integers',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/sum-of-two-integers/',
      level: 'medium',
    },
  ],
  'Linked List': [
    {
      id: 'll_1',
      qs: 'Reverse a Linked List',
      yt: 'https://youtu.be/RreHsOfi14w?si=fJ5QSp10JSpK9pBI',
      qs_link: 'https://leetcode.com/problems/reverse-linked-list/',
      level: 'easy',
    },
    {
      id: 'll_2',
      qs: 'Detect Cycle in a Linked List',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/linked-list-cycle/',
      level: 'easy',
    },
    {
      id: 'll_3',
      qs: 'Merge Two Sorted Lists',
      yt: 'https://youtu.be/RreHsOfi14w?si=szPqscASw51HLVUP',
      qs_link: 'https://leetcode.com/problems/merge-two-sorted-lists/',
      level: 'easy',
    },
    {
      id: 'll_4',
      qs: 'Merge K Sorted Lists',
      yt: 'https://youtu.be/Q64u-W3l3mA?si=-FmJOCBEhQd04bq5',
      qs_link: 'https://leetcode.com/problems/merge-k-sorted-lists/',
      level: 'hard',
    },
    {
      id: 'll_5',
      qs: 'Remove Nth Node From End Of List',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/remove-nth-node-from-end-of-list/',
      level: 'medium',
    },
    {
      id: 'll_6',
      qs: 'Reorder List',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/reorder-list/',
      level: 'medium',
    },
  ],
  'Dynamic Programming': [
    {
      id: 'dp_1',
      qs: 'Climbing Stairs',
      yt: 'https://youtu.be/6OjGE04Kx_M?si=dmjT5_kH7mYW5gIZ',
      qs_link: 'https://leetcode.com/problems/climbing-stairs/',
      level: 'easy',
    },
    {
      id: 'dp_2',
      qs: 'Coin Change',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/coin-change/',
      level: 'medium',
    },
    {
      id: 'dp_3',
      qs: 'Longest Increasing Subsequence',
      yt: 'https://youtu.be/DG50PJIx2SM?si=Zn-mVXb-HDC3uSPw',
      qs_link: 'https://leetcode.com/problems/longest-increasing-subsequence/',
      level: 'medium',
    },
    {
      id: 'dp_4',
      qs: 'Longest Common Subsequence',
      yt: 'https://youtu.be/aJNu_DLyOxY?si=zUbDbMAlhIeIoLYo',
      qs_link: 'https://leetcode.com/problems/longest-common-subsequence/',
      level: 'medium',
    },
    {
      id: 'dp_5',
      qs: 'Word Break Problem',
      yt: 'https://youtu.be/oBUpyPZ08zU?si=ddvusPWi3624G0mq',
      qs_link: 'https://leetcode.com/problems/word-break/',
      level: 'medium',
    },
    {
      id: 'dp_6',
      qs: 'Combination Sum',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/combination-sum-iv/',
      level: 'medium',
    },
    {
      id: 'dp_7',
      qs: 'House Robber',
      yt: 'https://youtu.be/SI6Pm8AKqnQ?si=jpAwTs9gmIrhzo-3',
      qs_link: 'https://leetcode.com/problems/house-robber/',
      level: 'medium',
    },
    {
      id: 'dp_8',
      qs: 'House Robber II',
      yt: 'https://youtu.be/5AxMZBirNKo?si=dVbPTGY8BVrxMDcm',
      qs_link: 'https://leetcode.com/problems/house-robber-ii/',
      level: 'medium',
    },
    {
      id: 'dp_9',
      qs: 'Decode Ways',
      yt: 'https://youtu.be/HW-y3gvQTVQ?si=AFgcEG6cfXHZYpF8',
      qs_link: 'https://leetcode.com/problems/decode-ways/',
      level: 'medium',
    },
    {
      id: 'dp_10',
      qs: 'Unique Paths',
      yt: 'https://youtu.be/DaakAKiCkyc?si=SGSZ0UhFLR4oqEld',
      qs_link: 'https://leetcode.com/problems/unique-paths/',
      level: 'medium',
    },
    {
      id: 'dp_11',
      qs: 'Jump Game',
      yt: 'https://youtu.be/pvg0yrD-E5w?si=VRKGm93yVnkd-a8o',
      qs_link: 'https://leetcode.com/problems/jump-game/',
      level: 'medium',
    },
  ],
  'DP on String': [
    {
      id: 'dp_string_1',
      qs: 'Longest Substring Without Repeating Characters',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/longest-substring-without-repeating-characters/',
      level: 'medium',
    },
    {
      id: 'dp_string_2',
      qs: 'Longest Repeating Character Replacement',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/longest-repeating-character-replacement/',
      level: 'medium',
    },
    {
      id: 'dp_string_3',
      qs: 'Minimum Window Substring',
      yt: 'https://www.youtube.com/watch?v=3Bp3OVD1EGc&t=125s',
      qs_link: 'https://leetcode.com/problems/minimum-window-substring/',
      level: 'hard',
    },
    {
      id: 'dp_string_4',
      qs: 'Valid Anagram',
      yt: 'https://www.youtube.com/watch?v=1tmEKyRAMuY',
      qs_link: 'https://leetcode.com/problems/valid-anagram/',
      level: 'easy',
    },
    {
      id: 'dp_string_5',
      qs: 'Group Anagrams',
      yt: 'https://www.youtube.com/watch?v=TNe3gF4r128',
      qs_link: 'https://leetcode.com/problems/group-anagrams/',
      level: 'medium',
    },
    {
      id: 'dp_string_6',
      qs: 'Valid Parentheses',
      yt: 'https://www.youtube.com/watch?v=3ssh_mk4LqY',
      qs_link: 'https://leetcode.com/problems/valid-parentheses/',
      level: 'easy',
    },
    {
      id: 'dp_string_7',
      qs: 'Valid Palindrome',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/valid-palindrome/',
      level: 'easy',
    },
    {
      id: 'dp_string_8',
      qs: 'Longest Palindromic Substring',
      yt: 'https://www.youtube.com/watch?v=n_kL8BkURVA',
      qs_link: 'https://leetcode.com/problems/longest-palindromic-substring/',
      level: 'medium',
    },
    {
      id: 'dp_string_9',
      qs: 'Palindromic Substrings',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/palindromic-substrings/',
      level: 'medium',
    },
    {
      id: 'dp_string_10',
      qs: 'Encode and Decode Strings (Leetcode Premium)',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/encode-and-decode-strings/',
      level: 'medium',
    },
  ],
  Graph: [
    {
      id: 'graph_1',
      qs: 'Clone Graph',
      yt: 'https://www.youtube.com/watch?v=z7mPg_xT5xk',
      qs_link: 'https://leetcode.com/problems/clone-graph/',
      level: 'medium',
    },
    {
      id: 'graph_2',
      qs: 'Course Schedule',
      yt: 'https://www.youtube.com/watch?v=lqjlGGMjSMU',
      qs_link: 'https://leetcode.com/problems/course-schedule/',
      level: 'medium',
    },
    {
      id: 'graph_3',
      qs: 'Pacific Atlantic Water Flow',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/pacific-atlantic-water-flow/',
      level: 'medium',
    },
    {
      id: 'graph_4',
      qs: 'Number of Islands',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/number-of-islands/',
      level: 'medium',
    },
    {
      id: 'graph_5',
      qs: 'Longest Consecutive Sequence',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/longest-consecutive-sequence/',
      level: 'medium',
    },
    {
      id: 'graph_6',
      qs: 'Alien Dictionary (Leetcode Premium)',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/alien-dictionary/',
      level: 'medium',
    },
    {
      id: 'graph_7',
      qs: 'Graph Valid Tree (Leetcode Premium)',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/graph-valid-tree/',
      level: 'medium',
    },
    {
      id: 'graph_8',
      qs: 'Number of Connected Components in an Undirected Graph (Leetcode Premium)',
      yt: 'Will soon come',
      qs_link:
        'https://leetcode.com/problems/number-of-connected-components-in-an-undirected-graph/',
      level: 'medium',
    },
  ],

  Interval: [
    {
      id: 'interval_1',
      qs: 'Insert Interval',
      yt: 'https://www.youtube.com/watch?v=XXaVIDIbUn4',
      qs_link: 'https://leetcode.com/problems/insert-interval/',
      level: 'medium',
    },
    {
      id: 'interval_2',
      qs: 'Merge Intervals',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/merge-intervals/',
      level: 'medium',
    },
    {
      id: 'interval_3',
      qs: 'Non-overlapping Intervals',
      yt: 'https://www.youtube.com/watch?v=0TYKyTwGOAs',
      qs_link: 'https://leetcode.com/problems/non-overlapping-intervals/',
      level: 'medium',
    },
    {
      id: 'interval_4',
      qs: 'Meeting Rooms (Leetcode Premium)',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/meeting-rooms/',
      level: 'medium',
    },
    {
      id: 'interval_5',
      qs: 'Meeting Rooms II (Leetcode Premium)',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/meeting-rooms-ii/',
      level: 'medium',
    },
  ],
  Matrix: [
    {
      id: 'matrix_1',
      qs: 'Set Matrix Zeroes',
      yt: 'https://leetcode.com',
      qs_link: 'https://leetcode.com/problems/set-matrix-zeroes/',
      level: 'medium',
    },
    {
      id: 'matrix_2',
      qs: 'Spiral Matrix',
      yt: 'https://www.youtube.com/watch?v=73j2ipxR958',
      qs_link: 'https://leetcode.com/problems/spiral-matrix/',
      level: 'medium',
    },
    {
      id: 'matrix_3',
      qs: 'Rotate Image',
      yt: 'https://www.youtube.com/watch?v=I48Z8QlQH8c',
      qs_link: 'https://leetcode.com/problems/rotate-image/',
      level: 'medium',
    },
    {
      id: 'matrix_4',
      qs: 'Word Search',
      yt: 'https://www.youtube.com/watch?v=whyax_vB8xY',
      qs_link: 'https://leetcode.com/problems/word-search/',
      level: 'medium',
    },
  ],
  'Binary Tree': [
    {
      id: 'binary_tree_1',
      qs: 'Maximum Depth of Binary Tree',
      yt: 'https://www.youtube.com/watch?v=uCvur520ejA',
      qs_link: 'https://leetcode.com/problems/maximum-depth-of-binary-tree/',
      level: 'easy',
    },
    {
      id: 'binary_tree_2',
      qs: 'Same Tree',
      yt: 'https://www.youtube.com/watch?v=YtoibyDlzk0',
      qs_link: 'https://leetcode.com/problems/same-tree/',
      level: 'easy',
    },
    {
      id: 'binary_tree_3',
      qs: 'Invert/Flip Binary Tree',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/invert-binary-tree/',
      level: 'easy',
    },
    {
      id: 'binary_tree_4',
      qs: 'Binary Tree Maximum Path Sum',
      yt: 'https://www.youtube.com/watch?v=Op6YFcs8R9M',
      qs_link: 'https://leetcode.com/problems/binary-tree-maximum-path-sum/',
      level: 'hard',
    },
    {
      id: 'binary_tree_5',
      qs: 'Binary Tree Level Order Traversal',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/binary-tree-level-order-traversal/',
      level: 'medium',
    },
    {
      id: 'binary_tree_6',
      qs: 'Serialize and Deserialize Binary Tree',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/serialize-and-deserialize-binary-tree/',
      level: 'hard',
    },
    {
      id: 'binary_tree_7',
      qs: 'Subtree of Another Tree',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/subtree-of-another-tree/',
      level: 'easy',
    },
    {
      id: 'binary_tree_8',
      qs: 'Construct Binary Tree from Preorder and Inorder Traversal',
      yt: 'https://youtu.be/G5c1wM3Kpuw?si=Nb6oDPbGuwr8d0ZB',
      qs_link:
        'https://leetcode.com/problems/construct-binary-tree-from-preorder-and-inorder-traversal/',
      level: 'medium',
    },
    {
      id: 'binary_tree_9',
      qs: 'Validate Binary Search Tree',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/validate-binary-search-tree/',
      level: 'medium',
    },
    {
      id: 'binary_tree_10',
      qs: 'Kth Smallest Element in a BST',
      yt: 'Will soon come',
      qs_link: 'https://leetcode.com/problems/kth-smallest-element-in-a-bst/',
      level: 'medium',
    },
    {
      id: 'binary_tree_11',
      qs: 'Lowest Common Ancestor of BST',
      yt: 'https://www.youtube.com/watch?v=Oi3_06ultic',
      qs_link: 'https://leetcode.com/problems/lowest-common-ancestor-of-a-binary-search-tree/',
      level: 'medium',
    },
    {
      id: 'binary_tree_12',
      qs: 'Implement Trie (Prefix Tree)',
      yt: 'https://www.youtube.com/watch?v=YXefcFMpemo',
      qs_link: 'https://leetcode.com/problems/implement-trie-prefix-tree/',
      level: 'medium',
    },
    {
      id: 'binary_tree_13',
      qs: 'Add and Search Word',
      yt: 'https://www.youtube.com/watch?v=wyUO7Oq9uS4',
      qs_link: 'https://leetcode.com/problems/add-and-search-word-data-structure-design/',
      level: 'medium',
    },
    {
      id: 'binary_tree_14',
      qs: 'Word Search II',
      yt: 'https://www.youtube.com/watch?v=DMP2bqW6URA',
      qs_link: 'https://leetcode.com/problems/word-search-ii/',
      level: 'hard',
    },
  ],
  'Advanced Problems': [
    {
      id: 'advanced_1',
      qs: 'Merge K Sorted Lists',
      yt: 'https://www.youtube.com/watch?v=Q64u-W3l3mA',
      qs_link: 'https://leetcode.com/problems/merge-k-sorted-lists/',
      level: 'hard',
    },
    {
      id: 'advanced_2',
      qs: 'Top K Frequent Elements',
      yt: 'https://www.youtube.com/watch?v=GLw4WbJdYLw',
      qs_link: 'https://leetcode.com/problems/top-k-frequent-elements/',
      level: 'medium',
    },
    {
      id: 'advanced_3',
      qs: 'Find Median from Data Stream',
      yt: 'https://www.youtube.com/watch?v=jnj87BSi9Is',
      qs_link: 'https://leetcode.com/problems/find-median-from-data-stream/',
      level: 'hard',
    },
  ],
};
